export class Media {
  // Used when the backend returns messages to a GET
  width?: number;
  height?: number;
  url?: string; // built from media_uuid returned by the backend

  // Used when posting a new image message or to display a temporary
  constructor(public media_uuid?: string) {}
}
